import React from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import Main from "./layout/main";
import About from "./pages/about";
import Services from "./pages/services";
import Setores from "./pages/setores";
import Contacts from "./pages/contacts";
import { Career } from "./pages/careers";
import TalkToUs from "./pages/talkToUs";
import FAQ from "./pages/faq";
function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Main />}>
          <Route path="/" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="setores" element={<Setores />} />
          <Route path="contact" element={<Contacts />} />
          <Route path="careers" element={<Career />} />
          <Route path="fale-conosco" element={<TalkToUs />} />
          <Route path="faq" element={<FAQ />} />
        </Route>
      </Routes>
      <Analytics />
      <SpeedInsights />
    </>
  );
}

export default App;
